import {Link, useLocation} from "react-router-dom";

const HOME_URL = "/home";
const SLIDESHOW_URL = "/slideshow";
const CELEBRATIONS_URL = "/celebrations";

interface NavigationToggleProps {
    isDarkTheme?: boolean;
    // "vertical" is used inside the mobile drawer: stacked links with full labels
    orientation?: "horizontal" | "vertical";
    // Called when a link is clicked (e.g. to close the drawer)
    onNavigate?: () => void;
}

export const NavigationToggle = ({
                                     isDarkTheme = false,
                                     orientation = "horizontal",
                                     onNavigate,
                                 }: NavigationToggleProps) => {
    const {pathname} = useLocation();
    const isVertical = orientation === "vertical";

    const linkBaseStyles = isVertical
        ? "block w-full px-4 py-3 rounded-lg font-medium transition-colors text-base"
        : "px-2 md:px-4 py-2 rounded-full font-medium transition-colors text-sm md:text-base";
    const activeLinkStyles = isDarkTheme ? "bg-white text-blue-950 hover:bg-gray-100" : "bg-blue-950 text-white hover:bg-blue-800";
    const inactiveLinkStyles = isDarkTheme ? "text-gray-300 hover:text-white" : "text-gray-600 hover:text-gray-900";

    const containerStyles = isVertical
        ? "flex flex-col gap-1"
        : "flex gap-1 md:gap-4 items-center";

    const linkClass = (url: string) =>
        `${linkBaseStyles} ${pathname === url ? activeLinkStyles : inactiveLinkStyles}`;

    return (
        <nav className={containerStyles}>
            <Link to={HOME_URL} className={linkClass(HOME_URL)} onClick={onNavigate}>
                Home
            </Link>
            <Link to={SLIDESHOW_URL} className={linkClass(SLIDESHOW_URL)} onClick={onNavigate}>
                {isVertical ? "Slideshow" : (
                    <>
                        <span className="sm:hidden">Show</span>
                        <span className="hidden sm:inline">Slideshow</span>
                    </>
                )}
            </Link>
            <Link to={CELEBRATIONS_URL} className={linkClass(CELEBRATIONS_URL)} onClick={onNavigate}>
                {isVertical ? "Celebrations" : (
                    <>
                        <span className="sm:hidden">🎉</span>
                        <span className="hidden sm:inline">Celebrations</span>
                    </>
                )}
            </Link>
        </nav>
    );
};
